import { useAgreementModal } from '@/hooks/auth/useAgreementModal';
import type { PartnerMordModalState } from '@mondivago/types';

export function usePartnerMordModal(): PartnerMordModalState {
  const result = useAgreementModal({
    documentType: 'partner_agreement',
    logTable: 'partner_agreement_logs',
    idField: 'partner_id',
    profileTable: 'partners',
    rpcName: 'insert_partner_agreement_log',
    seenKey: 'mondivago:partner-mord-modal-seen',
  });

  return {
    showModal: result.showModal,
    partnerId: result.profileId,
    activeAgreement: result.activeAgreement,
    hasNewVersion: result.hasNewVersion,
    acceptedVersion: result.acceptedVersion,
    loading: result.loading,
    handleClose: result.handleClose,
    openModal: result.openModal,
    refresh: result.refresh,
    acceptAgreement: result.acceptAgreement,
  };
}
